import { useId } from 'react';
import Stack from 'shell/components/Stack';
import Switch from 'shell/components/Switch';
import Text from 'shell/components/Text';

const SettingToggle = ({
    id: suppliedId,
    label,
    description,
    checked,
    disabled = false,
    tooltip,
    onChange,
    labelTextProps,
    descriptionTextProps,
}) => {
    const generatedId = useId();
    const id = suppliedId || generatedId;
    const descriptionId = description ? `${id}-description` : undefined;

    return (
        <Stack spacing={3}>
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'} spacing={3}>
                <Text id={id} {...labelTextProps}>
                    {label}
                </Text>
                <Switch
                    checked={Boolean(checked)}
                    disabled={disabled}
                    inputProps={{
                        'aria-labelledby': id,
                        'aria-describedby': descriptionId,
                    }}
                    tooltip={tooltip}
                    onChange={(_, value) => {
                        if (!disabled) onChange(value);
                    }}
                />
            </Stack>
            {description && (
                <Text id={descriptionId} {...descriptionTextProps}>
                    {description}
                </Text>
            )}
        </Stack>
    );
};

export default SettingToggle;
